import type { PdfZoomMode, PdfZoomState } from "./pdfPageViewport";

export type { PdfZoomMode, PdfZoomState };
export { getFitScales } from "./pdfPageViewport";

export const PDF_ZOOM_PERCENT_MIN = 25;
export const PDF_ZOOM_PERCENT_MAX = 400;
export const PDF_ZOOM_PERCENT_STEP = 10;

export const PDF_ZOOM_PERCENT_PRESETS = [50, 75, 100, 125, 150, 200, 300] as const;

export const clampZoomPercent = (percent: number) =>
  Math.min(PDF_ZOOM_PERCENT_MAX, Math.max(PDF_ZOOM_PERCENT_MIN, Math.round(percent)));

export const getZoomSelectValue = (zoom: PdfZoomState) =>
  zoom.mode === "percent" ? String(zoom.percent) : zoom.mode;

export const getZoomSelectLabel = (zoom: PdfZoomState) => {
  if (zoom.mode === "fit-page") return "Fit to page";
  if (zoom.mode === "fit-width") return "Fit to width";
  return `${zoom.percent}%`;
};

export const parseZoomSelectValue = (value: string): PdfZoomState => {
  if (value === "fit-page" || value === "fit-width") {
    return { mode: value, percent: 100 };
  }
  return { mode: "percent", percent: clampZoomPercent(Number(value) || 100) };
};

export const getPercentForFitMode = (
  mode: Exclude<PdfZoomMode, "percent">,
  fitWidthScale: number,
  fitPageScale: number
) => {
  if (mode === "fit-width") return 100;
  return clampZoomPercent(Math.round((fitPageScale / Math.max(fitWidthScale, 0.0001)) * 100));
};
